import { motion } from "framer-motion";
import {
  UserCheck,
  BadgeCheck,
  Wallet,
  Clock,
  ClipboardList,
  MapPin,
} from "lucide-react";

const reasons = [
  { icon: UserCheck, title: "Single Point of Contact", desc: "One dedicated manager who knows your property inside-out." },
  { icon: BadgeCheck, title: "Vetted & Skilled Teams", desc: "Background-checked, certified professionals on every job." },
  { icon: Wallet, title: "Transparent Pricing", desc: "Honest quotes. No surprises. Detailed line-items always." },
  { icon: Clock, title: "Rapid Response", desc: "Quick turnarounds and 24/7 emergency call-outs." },
  { icon: ClipboardList, title: "Full Documentation", desc: "Reports, photos, compliance logs — for every visit." },
  { icon: MapPin, title: "SA-Wide Coverage", desc: "Gauteng, Western Cape, KZN, Eastern Cape — and beyond." },
];

export const WhyUs = () => {
  return (
    <section
      id="why"
      className="relative py-24 md:py-36 bg-forest text-cream overflow-hidden"
      data-testid="why-us-section"
    >
      <div className="absolute inset-0 grain opacity-10" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start mb-20">
          <div className="lg:col-span-5">
            <div className="uppercase text-xs tracking-[0.3em] text-gold mb-6">
              Why Greenroute
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              We're not a vendor.
              <br />
              We're a <span className="italic text-gold">partner.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-cream/80 text-base md:text-lg leading-relaxed">
              Estate management is a long game. We invest in relationships, processes
              and quality assurance because we believe a property thrives when it's
              cared for by people who genuinely care.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-cream/10">
          {reasons.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={r.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="bg-forest p-8 md:p-10 hover:bg-forest-900 transition-colors duration-500"
                data-testid={`why-card-${i}`}
              >
                <Icon size={32} strokeWidth={1.25} className="text-gold mb-6" />
                <h3 className="font-serif text-2xl text-cream mb-3">{r.title}</h3>
                <p className="text-cream/70 text-sm leading-relaxed">{r.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
